export default __webpack_public_path__ + "static/media/CustoImage (2).6a0cd49e.png";